
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10.502","cy":"9.924","r":"7.991","stroke":"#007F32"}}),_c('path',{attrs:{"d":"M14.325 16.913l5.303 6.079c.478.572 1.32.644 1.885.16a1.363 1.363 0 00.16-1.907l-5.41-6.203","stroke":"#007F32","stroke-miterlimit":"10"}})])
          )
        }
      }
    